import React from "react";
import { Icon1, Icon2, Icon4, Icon5, Icon6 } from "@/assets";
import Image from "next/image";
import {
  Marquee,
  MarqueeContent,
  MarqueeFade,
} from "@/components/ui/shadcn-io/marquee";
import { fontSizes } from "@/constants/constants";
import { ButtonCta, LiveChatButton } from "@/components";
const ContactCompanies = () => {
  const items = [
    {
      image: Icon1,
      cta: true,
    },
    {
      image: Icon2,
    },
    {
      image: Icon4,
    },
    {
      image: Icon5,
    },
    {
      image: Icon6,
    },
  ];
  return (
    <div className="bg-gradient-to-br from-brand-800 via-brand-700 to-brand-600 px-4 md:px-0 py-10 md:py-16">
      <div className="max-w-[1350px] mx-auto">
        {/* Header Section */}
        <div className="text-center mb-12">
          <h1 className="text-xl sm:text-4xl md:text-6xl font-display font-semibold text-white mb-6 leading-tight">
            How We Can Help
          </h1>
          <p className="text-sm sm:text-lg md:text-xl text-gray-300 max-w-4xl mx-auto leading-relaxed">
            We coordinate the people and steps involved in getting a manuscript
            ready — writing support, editing, design, formatting, and promotion
            — under one process rather than several disconnected vendors. If
            you’re not sure exactly what your project needs yet, that’s a fine
            place to start the conversation.
          </p>
        </div>
      </div>
      <div className="flex w-full  ">
        <div
          className={` flex flex-col items-center justify-center text-center w-full  `}
        >
          {items[0]?.name && (
            <div className="py-10">
              <h1 className={`${fontSizes.text_4_xl} font-display font-semibold`}>{title}</h1>
              <p>{text}</p>
            </div>
          )}
          <div className="w-full relative overflow-hidden">
            <Marquee>
              <MarqueeContent pauseOnHover className="[--duration:30s] ">
                <div
                  className={`flex ${items[0]?.cta && "gap-8 md:gap-20"
                    }`}
                >
                  {Array.isArray(items) &&
                    items.map((item, index) => (
                      <div
                        key={index}
                        className={`flex justify-center items-center ${items[0]?.name && "flex-col"
                          }`}
                      >
                        <Image
                          className={`${!item.name && "brightness-50"
                            }`}
                          src={item?.image}
                          alt={item?.name || "Partner company logo"}
                        />
                        <p className="py-4">{items[0]?.cta && item?.name}</p>
                      </div>
                    ))}
                  {items[0]?.cta && <div className="w-16" />}
                </div>
              </MarqueeContent>

              <MarqueeFade side="left" />
              <MarqueeFade side="right" />
            </Marquee>

            <div className="pointer-events-none absolute inset-y-0 left-0 w-1/4 bg-gradient-to-r from-background"></div>
            <div className="pointer-events-none absolute inset-y-0 right-0 w-1/4 bg-gradient-to-l from-background"></div>
          </div>
          {items[0]?.name && items[0]?.cta && (
            <div className="flex gap-4 py-10  ">
              <LiveChatButton
                buttonText="Live Chat"
                classStyle={`text-[#fff] bg-[#1EA7DB] hover:bg-[#1EA7DB]/90 h-12 `}
              />
              <ButtonCta
                buttonText="Get a Quote"
                classStyle={`text-ink bg-[#61C1E5] hover:bg-[#61C1E5]/90 h-12 `}
              />
            </div>
          )}
        </div>
      </div>
      <div className="flex md:flex-row flex-col gap-4 justify-center items-center pt-8 md:pt-16">

        <LiveChatButton buttonText={"Self-Publishing Services"} classStyle={`text-[#fff] bg-[#1EA7DB] w-full md:w-[unset] hover:bg-[#1EA7DB]/90 h-12 flex items-center justify-center`} />
        <ButtonCta buttonText={"Get a Quote"} classStyle={`text-ink bg-[#61C1E5] hover:bg-[#61C1E5]/90 h-12 w-full flex items-center justify-center md:w-[unset] `} />
      </div>
    </div>
  );
};

export default ContactCompanies;
